module.exports = __webpack_public_path__ + "img/topbgc.ae63393d.png";